
import { z } from "zod";

export const demographicsSchema = z.object({
  age_group: z.string().optional(),
  gender: z.string().optional(),
  education_level: z.string().optional(),
  employment_status: z.string().optional(),
  political_leaning: z.string().optional(),
  income_range: z.string().optional(),
  residence_type: z.string().optional(),
});

export type DemographicsFormValues = z.infer<typeof demographicsSchema>;
